import React, { useEffect, useState } from 'react';
import Icon from 'screens/shared/icon';
import Input from 'screens/shared/form/input-field';
import { CLOUD_INIT_SUPPORTED_FILE_DEFAULT, CLOUD_INIT_SUPPORTED_FILE_TYPES } from 'constant/cloud-init';
import { Alert } from '@mui/material';
import { isEmptyObject } from 'utils';

export const UserDataField = ({
  value = '', onChange = (e) => e, name,
}) => {
  const [error, setError] = useState('');
  const [innerValue, setInnerValue] = useState('');
  const [supportedType, setSupportedType] = useState({});

  // const addLineEnding = () => {
  // if(!string.endsWith("\n")){
  //   string += "\n";
  // }

  // // let dummyFile = new File([new TextEncoder().encode(string)], "Edited content", {type: "text/plain"});
  // let dummyFile = new File([string], "Edited content", {
  //   type: "text/plain",
  // });

  // let reader = new FileReader();
  // reader.onload = (e) => this.urlDataField.set("value", reader.result);
  // reader.readAsDataURL(dummyFile);
  // };

  const fileChangeHandler = (e) => {
    const { files } = e.target;
    const reader = new window.FileReader();
    const fileType = files[0].type;
    const fileName = files[0].name;
    const _supportedType = CLOUD_INIT_SUPPORTED_FILE_TYPES.find(({ mimeTypes = [] }) => mimeTypes.includes(fileType));
    if (!_supportedType) {
      onChange('');
      setSupportedType({});
      return setError('The selected file is not supported!');
    }

    if (_supportedType.readOnly) reader.readAsDataURL(files[0]);
    else reader.readAsText(files[0]);

    reader.onload = (re) => {
      if (_supportedType.readOnly) setInnerValue(re.target.result?.split(',')[1]);
      else setInnerValue(re.target.result);
    };

    return setSupportedType({ ..._supportedType, fileName });
  };

  function inputHandler(newValue) {
    setInnerValue(newValue);
  }

  useEffect(() => {
    if (supportedType.readOnly) onChange(innerValue);
    else onChange(btoa(innerValue));
    // eslint-disable-next-line
  }, [innerValue]);

  useEffect(() => {
    if (value && value !== innerValue) {
      if (isEmptyObject(supportedType)) {
        setInnerValue(value);
        setSupportedType({ ...CLOUD_INIT_SUPPORTED_FILE_DEFAULT });
      } else if (supportedType.readOnly) setInnerValue(value);
      else setInnerValue(window.atob(value));
    }
    // eslint-disable-next-line
  }, [value]);

  return (
    <>
      <div className="image-selector overflow-hidden p-12">
        <span className="color-gray">User Data (Cloud Init)</span>
        <div>
          <label
            style={{
              marginTop: 10, border: '1px dashed lightgray', padding: 10, borderRadius: 12, display: 'flex', cursor: 'pointer',
            }}
            htmlFor={`import-file-${name}`}
          >
            <Icon name="cloud-upload-alt" style={{ fontSize: 30, color: 'lightgray' }} />
            <span style={{ marginLeft: 15 }}>
              <span style={{ fontSize: 18, color: 'gray', marginBottom: 10 }}>
                Import User data file
                <br />
              </span>
              {CLOUD_INIT_SUPPORTED_FILE_TYPES.map(({ extensions = [], label = '' }, i) => (
                <span className="f-12 color-gray" key={i}>
                  {`${label} (${extensions.join(', ')})`}
                  <br />
                </span>
              ))}
              {(!!supportedType.label || !!supportedType.fileName) && <hr />}
              {!!supportedType.label && <span className="color-base f-12 block">{`Type: ${supportedType.label}`}</span>}
              {!!supportedType.fileName && <span className="color-base f-12 block">{`Name: ${supportedType.fileName}`}</span>}
            </span>

            <input type="file" onChange={fileChangeHandler} style={{ display: 'none' }} id={`import-file-${name}`} />
          </label>
        </div>
        {!innerValue && !!error && (
          <p style={{ color: 'var(--color-danger)' }}>{error}</p>
        )}
        {(!!innerValue && supportedType.readOnly) && (
          <Alert className="m-t-12" severity="info">No preview available for binary files</Alert>
        )}
        {!supportedType.readOnly && (
          <div style={{ marginTop: 10 }}>
            <Input
              value={innerValue}
              label="User data editor / Preview"
              onChange={inputHandler}
              multiline
              maxRows="10"
              minRows="6"
              style={{ width: '100%' }}
            />
          </div>
        )}
      </div>
    </>
  );
};
